import { IWizardContext } from "./StepWizard";

export class WizardStep {
	public content: (next: (skip?: number) => void, prev: () => void, ctx: IWizardContext) => JSX.Element;
	public hideNext?: boolean;
	public hidePrevious?: boolean;
	public hideDots?: boolean;
	public Validate?: (ctx: IWizardContext) => boolean;
}
